// any positive value is acceptable. uses to open lesson navigation after a lesson page mount
// IndividualCard.tsx, LessonNavigation.tsx
export const LESSON_NAVIGATION = 'lesson-navigation';

// search query params
export const SEARCH_KEY = 'searchKey';
